import { render, staticRenderFns } from "./AutoReplies.vue?vue&type=template&id=e1f7695a&scoped=true&"
import script from "./AutoReplies.vue?vue&type=script&lang=js&"
export * from "./AutoReplies.vue?vue&type=script&lang=js&"
import style0 from "./AutoReplies.vue?vue&type=style&index=0&id=e1f7695a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f7695a",
  null
  
)

export default component.exports